export enum RegistrationType {
    composition = "composition",
    regular = "regular",
    unregisteredConsumer = "unregistered/consumer"
}
